export const SuccessErrorConst = {
    loginAgain: 'Login Successfully!',
    addedSuccess: 'Added Successfully!',
    updatedSuccess: 'Updated Successfully!',
    SUBMITTED: 'Submitted Successfully!',
    deleteSuccess: 'Deleted Successfully!',
    deleteSuccessD: 'Comming soon Successfully!',
    approveSuccess: 'Updated Successfully!',
    messageSuccess: 'Message sent successfully!',
    required: 'This field is required.',
    validEmail: 'Please enter valid email!.',
    noImageAdded: 'Please add atleast 1 image!.',
    changePassword:'Password  Changed successfully! ',
    commingsoon:'Comming soon Successfully!',
    Sign:'Sign up Successfully!',
    Reset_password:'Reset Password',
    updateProfile:"Profile successfully updated",
    updatePassword:'Password successfully updated',
    company:'Added Company successfully',
    Account:'Account Verification is Approved!',
    Confirmed:'Account Verification is  Not Approved!',
    reject:'Account Verification is  Rejected!'
    
   
};
